"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchToStore = exports.PREVIEW_DATASHEET_ID = exports.DEFAULT_FIELD_PERMISSION = exports.DateUnitType = exports.WhyRecordMoveType = exports.RecordMoveType = exports.SearchResultType = exports.UN_GROUP = exports.FieldOperateType = exports.QrAction = exports.BindAccount = exports.OrgChartStyleKeyType = exports.CalendarStyleKeyType = exports.GanttStyleKeyType = exports.GanttColorType = exports.CalendarColorType = exports.KanbanStyleKey = exports.GalleryStyleKeyType = exports.CellType = exports.PageType = exports.LayoutType = exports.MIN_COLUMN_WIDTH = exports.DEFAULT_COLUMN_WIDTH = exports.GanttRowHeight = exports.RowHeight = exports.RowHeightLevel = exports.ViewType = exports.DropDirectionType = exports.GuideWizardModule = exports.GuideUiTypeConstant = exports.ScreenWidth = exports.ToolBarMenuCardOpenState = exports.NotSupportFieldInstance = exports.DEFAULT_READ_ONLY_PERMISSION = exports.DEFAULT_EDITOR_PERMISSION = exports.DEFAULT_MANAGER_PERMISSION = exports.DEFAULT_PERMISSION = void 0;
const i18n_1 = require("../../../exports/i18n");
const types_1 = require("../../../types");
exports.DEFAULT_PERMISSION = {
    allowEditConfigurable: false,
    allowSaveConfigurable: false,
    childCreatable: false,
    copyable: false,
    descriptionEditable: false,
    editable: false,
    iconEditable: false,
    importable: false,
    manageable: false,
    movable: false,
    nodeAssignable: false,
    readable: false,
    removable: false,
    renamable: false,
    sharable: false,
    templateCreatable: false,
    exportable: false,
    viewCreatable: false,
    viewRenamable: false,
    viewRemovable: false,
    viewMovable: false,
    viewExportable: false,
    viewFilterable: false,
    columnSortable: false,
    columnHideable: false,
    fieldSortable: false,
    fieldGroupable: false,
    rowHighEditable: false,
    columnWidthEditable: false,
    columnCountEditable: false,
    fieldCreatable: false,
    fieldRenamable: false,
    fieldPropertyEditable: false,
    fieldRemovable: false,
    rowCreatable: false,
    rowRemovable: false,
    cellEditable: false,
    rowSortable: false,
    fieldPermissionManageable: false,
    viewLayoutEditable: false,
    viewStyleEditable: false,
    viewKeyFieldEditable: false,
    viewColorOptionEditable: false,
    viewManualSaveManageable: false,
    viewOptionSaveEditable: false
};
/**
 * manageable manager's permissions
 */
exports.DEFAULT_MANAGER_PERMISSION = {
    allowEditConfigurable: true,
    allowSaveConfigurable: true,
    childCreatable: true,
    copyable: true,
    descriptionEditable: true,
    editable: true,
    iconEditable: true,
    exportable: true,
    importable: true,
    manageable: true,
    movable: true,
    nodeAssignable: true,
    readable: true,
    removable: true,
    renamable: true,
    sharable: true,
    templateCreatable: true,
    viewCreatable: true,
    viewRenamable: true,
    viewRemovable: true,
    viewMovable: true,
    viewExportable: true,
    viewFilterable: true,
    columnSortable: true,
    columnHideable: true,
    rowSortable: true,
    fieldSortable: true,
    fieldGroupable: true,
    rowHighEditable: true,
    columnWidthEditable: true,
    columnCountEditable: true,
    fieldCreatable: true,
    fieldRenamable: true,
    fieldPropertyEditable: true,
    fieldRemovable: true,
    rowCreatable: true,
    rowRemovable: true,
    cellEditable: true,
    fieldPermissionManageable: true,
    viewLayoutEditable: true,
    viewStyleEditable: true,
    viewKeyFieldEditable: true,
    viewColorOptionEditable: true,
    viewManualSaveManageable: true,
    viewOptionSaveEditable: true
};
/**
 * editor's permissions
 */
exports.DEFAULT_EDITOR_PERMISSION = {
    allowEditConfigurable: false,
    allowSaveConfigurable: false,
    childCreatable: false,
    copyable: false,
    descriptionEditable: false,
    editable: true,
    iconEditable: false,
    exportable: false,
    importable: false,
    manageable: false,
    movable: false,
    nodeAssignable: false,
    readable: true,
    removable: false,
    renamable: false,
    sharable: true,
    templateCreatable: false,
    viewCreatable: true,
    viewRenamable: true,
    viewRemovable: true,
    viewMovable: true,
    viewExportable: false,
    viewFilterable: true,
    columnSortable: true,
    columnHideable: true,
    rowSortable: true,
    fieldSortable: true,
    fieldGroupable: true,
    rowHighEditable: true,
    columnWidthEditable: true,
    columnCountEditable: true,
    fieldCreatable: false,
    fieldRenamable: false,
    fieldPropertyEditable: false,
    fieldRemovable: false,
    rowCreatable: true,
    rowRemovable: true,
    cellEditable: true,
    fieldPermissionManageable: false,
    viewLayoutEditable: true,
    viewStyleEditable: true,
    viewKeyFieldEditable: true,
    viewColorOptionEditable: true,
    viewManualSaveManageable: false,
    viewOptionSaveEditable: true
};
/**
 * default readonly permissions
 */
exports.DEFAULT_READ_ONLY_PERMISSION = {
    allowEditConfigurable: false,
    allowSaveConfigurable: false,
    childCreatable: false,
    copyable: false,
    descriptionEditable: false,
    exportable: false,
    editable: false,
    iconEditable: false,
    importable: false,
    manageable: false,
    movable: false,
    nodeAssignable: false,
    readable: true,
    removable: false,
    renamable: false,
    sharable: false,
    templateCreatable: false,
    viewCreatable: false,
    viewRenamable: false,
    viewRemovable: false,
    viewMovable: false,
    viewExportable: false,
    viewFilterable: false,
    columnSortable: false,
    columnHideable: false,
    fieldSortable: false,
    fieldGroupable: false,
    rowHighEditable: false,
    columnWidthEditable: false,
    columnCountEditable: false,
    fieldCreatable: false,
    fieldRenamable: false,
    fieldPropertyEditable: false,
    fieldRemovable: false,
    rowCreatable: false,
    rowRemovable: false,
    cellEditable: false,
    rowSortable: false,
    fieldPermissionManageable: false,
    viewLayoutEditable: false,
    viewStyleEditable: false,
    viewKeyFieldEditable: false,
    viewColorOptionEditable: false,
    viewManualSaveManageable: false,
    viewOptionSaveEditable: false
};
exports.NotSupportFieldInstance = {
    id: 'fldError',
    name: (0, i18n_1.t)(i18n_1.Strings.error_wrong_data_in_current_column),
    type: types_1.FieldType.NotSupport,
    property: null,
};
var ToolBarMenuCardOpenState;
(function (ToolBarMenuCardOpenState) {
    ToolBarMenuCardOpenState["None"] = "None";
    ToolBarMenuCardOpenState["FieldHidden"] = "FieldHidden";
    ToolBarMenuCardOpenState["ExclusiveFieldHidden"] = "ExclusiveFieldHidden";
    ToolBarMenuCardOpenState["Filter"] = "Filter";
    ToolBarMenuCardOpenState["QueryFilter"] = "QueryFilter";
    ToolBarMenuCardOpenState["Group"] = "Group";
    ToolBarMenuCardOpenState["Sort"] = "Sort";
    ToolBarMenuCardOpenState["RowHeight"] = "RowHeight";
    ToolBarMenuCardOpenState["GallerySetting"] = "GallerySetting";
    ToolBarMenuCardOpenState["OrgChartSetting"] = "OrgChartSetting";
    // special: this is a component in the toolbar, just clean for "display" component, so place it here to control.by @mayne
    ToolBarMenuCardOpenState["ViewSwitcher"] = "ViewSwitcher";
    ToolBarMenuCardOpenState["KanbanFieldHidden"] = "KanbanFieldHidden";
    ToolBarMenuCardOpenState["Share"] = "Share";
})(ToolBarMenuCardOpenState = exports.ToolBarMenuCardOpenState || (exports.ToolBarMenuCardOpenState = {}));
exports.ScreenWidth = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1440,
    xxxl: 1600,
};
var GuideUiTypeConstant;
(function (GuideUiTypeConstant) {
    GuideUiTypeConstant["Modal"] = "modal";
    GuideUiTypeConstant["Slideout"] = "slideout";
    GuideUiTypeConstant["Hotspot"] = "hotspot";
    GuideUiTypeConstant["Popover"] = "popover";
    GuideUiTypeConstant["Notice"] = "notice";
    GuideUiTypeConstant["Questionnaire"] = "questionnaire";
    GuideUiTypeConstant["Breath"] = "breath";
    GuideUiTypeConstant["PrivacyModal"] = "privacyModal";
})(GuideUiTypeConstant = exports.GuideUiTypeConstant || (exports.GuideUiTypeConstant = {}));
var GuideWizardModule;
(function (GuideWizardModule) {
    GuideWizardModule["Notice"] = "notice";
    GuideWizardModule["Guide"] = "guide";
})(GuideWizardModule = exports.GuideWizardModule || (exports.GuideWizardModule = {}));
var DropDirectionType;
(function (DropDirectionType) {
    DropDirectionType["BEFORE"] = "before";
    DropDirectionType["AFTER"] = "after";
    DropDirectionType["NONE"] = "";
})(DropDirectionType = exports.DropDirectionType || (exports.DropDirectionType = {}));
var ViewType;
(function (ViewType) {
    ViewType[ViewType["NotSupport"] = 0] = "NotSupport";
    ViewType[ViewType["Grid"] = 1] = "Grid";
    ViewType[ViewType["Kanban"] = 2] = "Kanban";
    ViewType[ViewType["Gallery"] = 3] = "Gallery";
    ViewType[ViewType["Form"] = 4] = "Form";
    ViewType[ViewType["Calendar"] = 5] = "Calendar";
    ViewType[ViewType["Gantt"] = 6] = "Gantt";
    ViewType[ViewType["OrgChart"] = 7] = "OrgChart";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var RowHeightLevel;
(function (RowHeightLevel) {
    RowHeightLevel[RowHeightLevel["Short"] = 1] = "Short";
    RowHeightLevel[RowHeightLevel["Medium"] = 2] = "Medium";
    RowHeightLevel[RowHeightLevel["Tall"] = 3] = "Tall";
    RowHeightLevel[RowHeightLevel["ExtraTall"] = 4] = "ExtraTall";
})(RowHeightLevel = exports.RowHeightLevel || (exports.RowHeightLevel = {}));
exports.RowHeight = {
    Short: 32,
    Medium: 57,
    Tall: 104,
    ExtraTall: 152,
};
exports.GanttRowHeight = {
    Short: 32,
    Medium: 40,
    Tall: 56,
};
exports.DEFAULT_COLUMN_WIDTH = 200;
exports.MIN_COLUMN_WIDTH = 80;
var LayoutType;
(function (LayoutType) {
    LayoutType["Flex"] = "flex";
    LayoutType["List"] = "list";
})(LayoutType = exports.LayoutType || (exports.LayoutType = {}));
var PageType;
(function (PageType) {
    PageType[PageType["Datasheet"] = 0] = "Datasheet";
    PageType[PageType["DataSpace"] = 1] = "DataSpace";
})(PageType = exports.PageType || (exports.PageType = {}));
var CellType;
(function (CellType) {
    CellType["GroupTab"] = "GroupTab";
    CellType["Add"] = "AddRecord";
    CellType["Blank"] = "Blank";
    CellType["Record"] = "Record";
})(CellType = exports.CellType || (exports.CellType = {}));
var GalleryStyleKeyType;
(function (GalleryStyleKeyType) {
    GalleryStyleKeyType["LayoutType"] = "layoutType";
    GalleryStyleKeyType["CardCount"] = "cardCount";
    GalleryStyleKeyType["CoverFieldId"] = "coverFieldId";
    GalleryStyleKeyType["IsCoverFit"] = "isCoverFit";
    GalleryStyleKeyType["IsAutoLayout"] = "isAutoLayout";
    GalleryStyleKeyType["IsColNameVisible"] = "isColNameVisible";
})(GalleryStyleKeyType = exports.GalleryStyleKeyType || (exports.GalleryStyleKeyType = {}));
var KanbanStyleKey;
(function (KanbanStyleKey) {
    KanbanStyleKey["CoverFieldId"] = "coverFieldId";
    KanbanStyleKey["IsCoverFit"] = "isCoverFit";
    KanbanStyleKey["KanbanFieldId"] = "kanbanFieldId";
    KanbanStyleKey["IsColNameVisible"] = "isColNameVisible";
    KanbanStyleKey["HiddenGroupMap"] = "hiddenGroupMap";
})(KanbanStyleKey = exports.KanbanStyleKey || (exports.KanbanStyleKey = {}));
var CalendarColorType;
(function (CalendarColorType) {
    CalendarColorType["Custom"] = "Custom";
})(CalendarColorType = exports.CalendarColorType || (exports.CalendarColorType = {}));
var GanttColorType;
(function (GanttColorType) {
    GanttColorType["Custom"] = "Custom";
    GanttColorType["SingleSelect"] = "SingleSelect";
})(GanttColorType = exports.GanttColorType || (exports.GanttColorType = {}));
var GanttStyleKeyType;
(function (GanttStyleKeyType) {
    GanttStyleKeyType["ColorOption"] = "colorOption";
    GanttStyleKeyType["StartFieldId"] = "startFieldId";
    GanttStyleKeyType["EndFieldId"] = "endFieldId";
    GanttStyleKeyType["WorkDays"] = "workDays";
    GanttStyleKeyType["OnlyCalcWorkDay"] = "onlyCalcWorkDay";
    GanttStyleKeyType["LinkFieldId"] = "linkFieldId";
    GanttStyleKeyType["AutoTaskLayout"] = "autoTaskLayout";
})(GanttStyleKeyType = exports.GanttStyleKeyType || (exports.GanttStyleKeyType = {}));
var CalendarStyleKeyType;
(function (CalendarStyleKeyType) {
    CalendarStyleKeyType["ColorOption"] = "colorOption";
    CalendarStyleKeyType["StartFieldId"] = "startFieldId";
    CalendarStyleKeyType["EndFieldId"] = "endFieldId";
    CalendarStyleKeyType["IsColNameVisible"] = "isColNameVisible";
})(CalendarStyleKeyType = exports.CalendarStyleKeyType || (exports.CalendarStyleKeyType = {}));
var OrgChartStyleKeyType;
(function (OrgChartStyleKeyType) {
    OrgChartStyleKeyType["CoverFieldId"] = "coverFieldId";
    OrgChartStyleKeyType["IsCoverFit"] = "isCoverFit";
    OrgChartStyleKeyType["IsColNameVisible"] = "isColNameVisible";
    OrgChartStyleKeyType["LinkFieldId"] = "linkFieldId";
    OrgChartStyleKeyType["Horizontal"] = "horizontal";
})(OrgChartStyleKeyType = exports.OrgChartStyleKeyType || (exports.OrgChartStyleKeyType = {}));
var BindAccount;
(function (BindAccount) {
    BindAccount[BindAccount["DINGDING"] = 0] = "DINGDING";
    BindAccount[BindAccount["WECHAT"] = 1] = "WECHAT";
    BindAccount[BindAccount["QQ"] = 2] = "QQ";
    BindAccount[BindAccount["WECOM"] = 3] = "WECOM";
})(BindAccount = exports.BindAccount || (exports.BindAccount = {}));
var QrAction;
(function (QrAction) {
    QrAction[QrAction["LOGIN"] = 0] = "LOGIN";
    QrAction[QrAction["BIND"] = 1] = "BIND";
    QrAction[QrAction["TO_WORK_SPACE"] = 2] = "TO_WORK_SPACE";
})(QrAction = exports.QrAction || (exports.QrAction = {}));
var FieldOperateType;
(function (FieldOperateType) {
    FieldOperateType[FieldOperateType["FieldSetting"] = 0] = "FieldSetting";
    FieldOperateType[FieldOperateType["FieldDesc"] = 1] = "FieldDesc";
})(FieldOperateType = exports.FieldOperateType || (exports.FieldOperateType = {}));
exports.UN_GROUP = 'UN_GROUP';
var SearchResultType;
(function (SearchResultType) {
    SearchResultType["Cell"] = "Cell";
    SearchResultType["Record"] = "Record";
})(SearchResultType = exports.SearchResultType || (exports.SearchResultType = {}));
var RecordMoveType;
(function (RecordMoveType) {
    RecordMoveType["OutOfView"] = "OutOfView";
    RecordMoveType["WillMove"] = "WillMove";
    RecordMoveType["NotMove"] = "NotMove";
    RecordMoveType["Deleted"] = "Deleted";
})(RecordMoveType = exports.RecordMoveType || (exports.RecordMoveType = {}));
var WhyRecordMoveType;
(function (WhyRecordMoveType) {
    WhyRecordMoveType["UpdateRecord"] = "UpdateRecord";
    WhyRecordMoveType["NewRecord"] = "NewRecord";
})(WhyRecordMoveType = exports.WhyRecordMoveType || (exports.WhyRecordMoveType = {}));
var DateUnitType;
(function (DateUnitType) {
    DateUnitType["Week"] = "Week";
    DateUnitType["Month"] = "Month";
    DateUnitType["Quarter"] = "Quarter";
    DateUnitType["Year"] = "Year";
})(DateUnitType = exports.DateUnitType || (exports.DateUnitType = {}));
exports.DEFAULT_FIELD_PERMISSION = {
    editable: false,
    readable: false,
};
exports.PREVIEW_DATASHEET_ID = 'previewDatasheet';
var DispatchToStore;
(function (DispatchToStore) {
    DispatchToStore["Local"] = "local";
    DispatchToStore["Remote"] = "remote";
    DispatchToStore["All"] = "all";
})(DispatchToStore = exports.DispatchToStore || (exports.DispatchToStore = {}));
//# sourceMappingURL=constants.js.map